/**
 * @generated SignedSource<<c8150b45e41048bfba095ba618c09c83>>
 * @relayHash abbe28b997f121d37d2a6bcf9de50587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec

import type { ConcreteRequest } from 'relay-runtime';
export type EditorUserPreferencesProviderMutation$variables = {
  toolbarDockingInitialPosition: string;
};
export type EditorUserPreferencesProviderMutation$data = {
  readonly updateUserPreferences: {
    readonly confluenceEditorSettings: {
      readonly toolbarDockingInitialPosition: string | null;
    } | null;
  } | null;
};
export type EditorUserPreferencesProviderMutation = {
  response: EditorUserPreferencesProviderMutation$data;
  variables: EditorUserPreferencesProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toolbarDockingInitialPosition"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "toolbarDockingInitialPosition",
                "variableName": "toolbarDockingInitialPosition"
              }
            ],
            "kind": "ObjectValue",
            "name": "confluenceEditorSettingsInput"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceEditorSettings",
        "kind": "LinkedField",
        "name": "confluenceEditorSettings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "toolbarDockingInitialPosition"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorUserPreferencesProviderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorUserPreferencesProviderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "abbe28b997f121d37d2a6bcf9de50587",
    "id": "f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec",
    "metadata": {},
    "name": "EditorUserPreferencesProviderMutation",
    "operationKind": "mutation",
    "text": "mutation EditorUserPreferencesProviderMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
  }
};
})();

(node as any).hash = "58cff6da35ff84f165c997ef5ed48166";

export default node;
